// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3IMR9","errors":"Errors_errors__AnPp7"};